import { render, staticRenderFns } from "./Choice.vue?vue&type=template&id=6d787d0a&scoped=true&"
import script from "./Choice.vue?vue&type=script&lang=ts&"
export * from "./Choice.vue?vue&type=script&lang=ts&"
import style0 from "./Choice.vue?vue&type=style&index=0&id=6d787d0a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d787d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
